module.exports = __webpack_public_path__ + "5e49e07c3b3bf0c8677605391b7cacbc.png";